// extracted by mini-css-extract-plugin
module.exports = {"mapWidget":"Map_mapWidget__A6ETx","status":"Map_status__Qm4Fg"};